export const ROOT = 'StepOne/form/brandVehicle';

export const FETCH_BRAND_VEHICLE_TOP_REQUEST = `${ROOT}/FETCH_BRAND_VEHICLE_TOP_REQUEST`;
export const FETCH_BRAND_VEHICLE_TOP_FAILURE = `${ROOT}/FETCH_BRAND_VEHICLE_TOP_FAILURE`;
export const FETCH_BRAND_VEHICLE_TOP_SUCCESS = `${ROOT}/FETCH_BRAND_VEHICLE_TOP_SUCCESS`;
